import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../../../../Support/with_presenter';
import {TransferWorkoutPresenter} from './TransferWorkoutPresenter';
import {FullWorkout} from '../../../../Models/FullWorkout';
import {useNavigate} from 'react-router-dom';
import {ObservableNetworkRequestStatusView} from '../../Utils/ObservableNetworkRequestStatusView';
import {CrewMember} from '../../../../Models/Crew';

interface OwnProps {
    className?: string;
    fullWorkout: FullWorkout
}

const TransferWorkoutComponent: FunctionComponent<OwnProps & PresenterProps<TransferWorkoutPresenter>> = observer(
    ({presenter, className, fullWorkout}) => {
        const navigate = useNavigate();
        return (
            <div className="card mb-3 mt-lg-0 mt-3">
                <div className="card-title">
                    <h5>Transfer your workout</h5>
                </div>
                <div className="card-body d-flex flex-column">
                    {fullWorkout.original_user_id &&
                        <p>This workout was given to you, you can return it or send it to another crew member.</p>
                    }
                    {!fullWorkout.original_user_id &&
                        <p>Select a crew member to which you want to transfer your workout:</p>
                    }
                        <ObservableNetworkRequestStatusView
                            result={presenter.crews}
                            loader={() => <span>Loading crew members</span>}
                            error={() => <span>Error loading crew members</span>}
                            component={(data) => {
                                const uniqueMembersMap = new Map<string, CrewMember>();

                                data.forEach(crew => {
                                    crew.members.forEach(member => {
                                        const id = member.userId?.toString();
                                        if (id && !member.isMe && !uniqueMembersMap.has(id)) {
                                            uniqueMembersMap.set(id, member);
                                        }
                                    });
                                });


                                const uniqueMembers = Array.from(uniqueMembersMap.values());

                                return (
                                    <div className="mb-3">
                                        <select
                                            className="form-select"
                                            value={presenter.selectedId.toString() ?? ''}
                                            name="crewMember"
                                            onChange={(e) => {
                                                presenter.setSelectedId(e.target.value.toString());
                                            }}
                                        >
                                            <option value="">Select a crew member</option>
                                            {uniqueMembers.map((member) => (
                                                <option key={member.userId} value={member.userId?.toString()}>
                                                    {member.firstName} {member.lastName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                );
                            }}
                        /> 
                        <div className="d-flex flex-row justify-content-end">
                            {fullWorkout.original_user_id &&
                                <button
                                    className="btn btn-primary me-2"
                                    disabled={presenter.isSaving}
                                    onClick={async () => {
                                        if (confirm('Are you sure you want to return this workout?')) {
                                            const result = await presenter.returnToOwner();
                                        }
                                    }}
                                >
                                    Return
                                </button>
                            }
                            <button
                                className="btn btn-primary"
                                disabled={presenter.isDisabled || presenter.isSaving}
                                onClick={async () => {
                                    if (confirm('Are you sure you want to transfer this workout?')) {
                                        const result = await presenter.submit();
                                    }
                                }}
                            >
                                Transfer
                            </button>
                        </div>
                </div>
            </div>
        );
    }
);

export const TransferWorkout = withPresenter<TransferWorkoutPresenter, OwnProps>(
    (props, component) => new TransferWorkoutPresenter(
        props.fullWorkout.id,
        props.fullWorkout.original_user_id,
        component.network.workouts,
        component.network.crews,
    ),
    TransferWorkoutComponent,
);
